/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SignupImport } from './routes/signup'
import { Route as MeetingsImport } from './routes/meetings'
import { Route as LoginImport } from './routes/login'
import { Route as DriversImport } from './routes/drivers'
import { Route as AboutImport } from './routes/about'
import { Route as IndexImport } from './routes/index'
import { Route as SessionSessionIdImport } from './routes/session_.$sessionId'
import { Route as MeetingsMeetingIdImport } from './routes/meetings_.$meetingId'

// Create/Update Routes

const SignupRoute = SignupImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRoute,
} as any)

const MeetingsRoute = MeetingsImport.update({
  id: '/meetings',
  path: '/meetings',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const DriversRoute = DriversImport.update({
  id: '/drivers',
  path: '/drivers',
  getParentRoute: () => rootRoute,
} as any)

const AboutRoute = AboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SessionSessionIdRoute = SessionSessionIdImport.update({
  id: '/session_/$sessionId',
  path: '/session/$sessionId',
  getParentRoute: () => rootRoute,
} as any)

const MeetingsMeetingIdRoute = MeetingsMeetingIdImport.update({
  id: '/meetings_/$meetingId',
  path: '/meetings/$meetingId',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutImport
      parentRoute: typeof rootRoute
    }
    '/drivers': {
      id: '/drivers'
      path: '/drivers'
      fullPath: '/drivers'
      preLoaderRoute: typeof DriversImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/meetings': {
      id: '/meetings'
      path: '/meetings'
      fullPath: '/meetings'
      preLoaderRoute: typeof MeetingsImport
      parentRoute: typeof rootRoute
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupImport
      parentRoute: typeof rootRoute
    }
    '/meetings_/$meetingId': {
      id: '/meetings_/$meetingId'
      path: '/meetings/$meetingId'
      fullPath: '/meetings/$meetingId'
      preLoaderRoute: typeof MeetingsMeetingIdImport
      parentRoute: typeof rootRoute
    }
    '/session_/$sessionId': {
      id: '/session_/$sessionId'
      path: '/session/$sessionId'
      fullPath: '/session/$sessionId'
      preLoaderRoute: typeof SessionSessionIdImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/drivers': typeof DriversRoute
  '/login': typeof LoginRoute
  '/meetings': typeof MeetingsRoute
  '/signup': typeof SignupRoute
  '/meetings/$meetingId': typeof MeetingsMeetingIdRoute
  '/session/$sessionId': typeof SessionSessionIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/drivers': typeof DriversRoute
  '/login': typeof LoginRoute
  '/meetings': typeof MeetingsRoute
  '/signup': typeof SignupRoute
  '/meetings/$meetingId': typeof MeetingsMeetingIdRoute
  '/session/$sessionId': typeof SessionSessionIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/drivers': typeof DriversRoute
  '/login': typeof LoginRoute
  '/meetings': typeof MeetingsRoute
  '/signup': typeof SignupRoute
  '/meetings_/$meetingId': typeof MeetingsMeetingIdRoute
  '/session_/$sessionId': typeof SessionSessionIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/drivers'
    | '/login'
    | '/meetings'
    | '/signup'
    | '/meetings/$meetingId'
    | '/session/$sessionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/drivers'
    | '/login'
    | '/meetings'
    | '/signup'
    | '/meetings/$meetingId'
    | '/session/$sessionId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/drivers'
    | '/login'
    | '/meetings'
    | '/signup'
    | '/meetings_/$meetingId'
    | '/session_/$sessionId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  DriversRoute: typeof DriversRoute
  LoginRoute: typeof LoginRoute
  MeetingsRoute: typeof MeetingsRoute
  SignupRoute: typeof SignupRoute
  MeetingsMeetingIdRoute: typeof MeetingsMeetingIdRoute
  SessionSessionIdRoute: typeof SessionSessionIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  DriversRoute: DriversRoute,
  LoginRoute: LoginRoute,
  MeetingsRoute: MeetingsRoute,
  SignupRoute: SignupRoute,
  MeetingsMeetingIdRoute: MeetingsMeetingIdRoute,
  SessionSessionIdRoute: SessionSessionIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/about",
        "/drivers",
        "/login",
        "/meetings",
        "/signup",
        "/meetings_/$meetingId",
        "/session_/$sessionId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/about": {
      "filePath": "about.tsx"
    },
    "/drivers": {
      "filePath": "drivers.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/meetings": {
      "filePath": "meetings.tsx"
    },
    "/signup": {
      "filePath": "signup.tsx"
    },
    "/meetings_/$meetingId": {
      "filePath": "meetings_.$meetingId.tsx"
    },
    "/session_/$sessionId": {
      "filePath": "session_.$sessionId.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
